// Start reporting errors before any other code runs.
import {
  startReportingErrors,
  reportError,
} from '@/modules/errorReporting';
startReportingErrors();

import Vue from 'vue';
import App from '@/App';
import axios from 'axios';
import router from '@/router';
import store from '@/store/index';
import vuetify from '@/plugins/vuetify';
import { apolloProvider } from '@/plugins/apollo';
import { Auth0Plugin } from '@/auth';
import { getEnvironmentConfig } from '@/modules';
import { NodeEnv } from '@/enums';
import('@/assets/styles/main.css');

Vue.config.productionTip = false;

// Report errors found by Vue to Google Cloud Error Reporting (in hosted environments only).
if (process.env.NODE_ENV !== NodeEnv.DEVELOPMENT) {
  Vue.config.errorHandler = (error) => {
    reportError(error);
  };
}

// If mock environment variable is present, start mock service worker.
if (process.env.VUE_APP_MOCK) {
  const {
    registerServiceWorker,
  } = require('@/mocks/registerServiceWorker');
  registerServiceWorker();
}

const auth0Config = getEnvironmentConfig('auth0');

Vue.use(Auth0Plugin, {
  domain: auth0Config.domain,
  clientId: auth0Config.clientId,
  audience: auth0Config.audience,
  onRedirectCallback: (appState) => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    );
  },
});

new Vue({
  router,
  store,
  vuetify,
  axios,
  apolloProvider,
  render: (h) => h(App),
}).$mount('#app');
